{
	"title": "E-Accreditation",
	"tabs": {
		"label": "E-Accreditation sections",
		"overview": "Overview",
		"cards": "Cards",
		"printBatches": "Print batches",
		"history": "Activation history",
		"toActivate_one": "{{n}} printed card waiting for activation",
		"toActivate_other": "{{n}} printed cards waiting for activation"
	},
	"state": {
		"NOT_PRINTED": "Not printed",
		"PRINTED": "Ready to collect",
		"COLLECTED": "Received",
		"ACTIVE": "Active",
		"LOST": "Lost",
		"REPLACED": "Replaced",
		"VOID": "Void",
		"READY_TO_GENERATE": "Ready to generate",
		"GENERATED": "Generated",
		"PRINTING": "At the printer"
	},
	"stateHint": {
		"NOT_PRINTED": "Approved, waiting to be printed.",
		"PRINTED": "Back from the printer, ready to send or collect. It opens no door until activated.",
		"COLLECTED": "The NOC received it. Waiting for activation.",
		"ACTIVE": "Works at every zone on the card until its valid-until date.",
		"LOST": "Reported lost, stolen or damaged. It no longer works.",
		"REPLACED": "A new card was issued in its place.",
		"VOID": "The record is no longer approved, so the card no longer counts.",
		"READY_TO_GENERATE": "In a print batch. Its card file is not made yet.",
		"GENERATED": "Its card file is made, waiting for the print shop (or for its NOC to print it).",
		"PRINTING": "At the print shop."
	},
	"batchStatus": {
		"OPEN": "Open",
		"PRINTED": "Back from printer",
		"GENERATED": "Files made",
		"PRINTING": "At the printer"
	},
	"batchStatusHint": {
		"OPEN": "Made. Its card files are not made yet.",
		"PRINTED": "Back from the printer. Mark cards received as each NOC collects them, then activate.",
		"GENERATED": "Card files made (ZIP), waiting for the print shop.",
		"PRINTING": "At the print shop."
	},
	"result": {
		"COMPLETE": "Completed",
		"PARTIAL": "Partial"
	},
	"resultHint": {
		"COMPLETE": "Every card in the activation was activated.",
		"PARTIAL": "Some cards were skipped, for example because they were not printed or were lost."
	},
	"guide": {
		"cardsTitle": "Card states",
		"batchesTitle": "Print batch statuses",
		"historyTitle": "Activation results"
	},
	"incidentKind": {
		"LOST": "Lost",
		"STOLEN": "Stolen",
		"DAMAGED": "Damaged"
	},
	"incidentKindInline": {
		"LOST": "lost",
		"STOLEN": "stolen",
		"DAMAGED": "damaged"
	},
	"common": {
		"close": "Close",
		"cancel": "Cancel",
		"ofN": "of {{n}}",
		"optional": "Optional",
		"byName": "by {{name}}",
		"notYet": "Not yet"
	},
	"bulk": {
		"tooMany": "At most {{max}} cards at once"
	},
	"activate": {
		"title_one": "Activate {{n}} card",
		"title_other": "Activate {{n}} cards",
		"subtitle_one": "{{n}} card selected",
		"subtitle_other": "{{n}} cards selected",
		"info": "Each card keeps the access codes it has now. Open a card to change one person's access.",
		"willSkip_one": "{{n}} selected card can't be activated and will be skipped.",
		"willSkip_other": "{{n}} selected cards can't be activated and will be skipped.",
		"validUntil": "Valid until",
		"validUntilHint": "Defaults to the last day of the Games ({{date}}).",
		"validUntilHintNone": "The last day the card works.",
		"validUntilRequired": "Set a validity date.",
		"validUntilPast": "Choose today or a later date.",
		"warn": "Access starts straight away at every zone on the card.",
		"confirm_one": "Activate {{n}}",
		"confirm_other": "Activate {{n}}",
		"done_one": "{{n}} card activated",
		"done_other": "{{n}} cards activated",
		"failed": "Couldn't activate the cards",
		"resultTitle": "Activation done",
		"activated": "Activated",
		"skipped": "Skipped",
		"skippedList": "Skipped cards"
	},
	"activateSkip": {
		"not_in_scope": "Not one of your cards",
		"not_printed": "Card is not printed yet",
		"already_active": "Already active",
		"lost": "Card is lost",
		"void": "Card is no longer valid"
	},
	"print": {
		"title": "Add to print batch",
		"subtitle_one": "{{n}} card selected",
		"subtitle_other": "{{n}} cards selected",
		"info": "A new print batch is made with the cards that can print. Then generate its cards from the Print batches tab.",
		"willSkip_one": "{{n}} selected card can't go to print and will be skipped.",
		"willSkip_other": "{{n}} selected cards can't go to print and will be skipped.",
		"notes": "Notes",
		"confirm": "Make print batch",
		"done_one": "Print batch {{name}} made with {{n}} card",
		"done_other": "Print batch {{name}} made with {{n}} cards",
		"failed": "Couldn't make the print batch",
		"resultTitle": "Print batch made",
		"added": "In the batch",
		"skipped": "Skipped",
		"skippedList": "Skipped cards",
		"viewBatch": "View batch",
		"kindLabel": "Who prints",
		"kindHostHint": "The host takes the card files to its print shop.",
		"kindSelfHint": "One organisation's cards. Its NOC downloads the card files and prints them.",
		"kindSelfManyOrgs": "Unable to use NOC prints: the cards are from {{n}} different NOCs.",
		"kindSelfNeedsOrgFilter": "Unable to use NOC prints: filter the list to one NOC first."
	},
	"printSkip": {
		"not_in_scope": "Not one of your cards",
		"not_printable": "Not waiting to be printed",
		"in_batch": "Already in a print batch",
		"no_photo": "No photo"
	},
	"report": {
		"title": "Report lost or stolen",
		"kind": "What happened",
		"date": "Date",
		"where": "Where",
		"police": "Police report no.",
		"policeHint": "Required when the card was stolen.",
		"note": "Remarks",
		"warnTitle": "The card stops working straight away",
		"warnBody_one": "The holder can't enter any venue with it. You can undo this for {{n}} minute.",
		"warnBody_other": "The holder can't enter any venue with it. You can undo this for {{n}} minutes.",
		"confirm": "Deactivate card",
		"done": "Card deactivated",
		"failed": "Couldn't report the card",
		"errors": {
			"date": "Enter the date.",
			"dateFuture": "The date can't be in the future.",
			"police": "Enter the police report number."
		}
	},
	"undo": {
		"banner": "Reported {{kind}} at {{time}}. Made a mistake? You can undo this until {{until}}.",
		"button": "Undo report",
		"done": "Report undone",
		"failed": "Couldn't undo the report"
	},
	"lookup": {
		"title": "Find a card",
		"subtitle": "Type the card or registration number, or scan the QR code on the card.",
		"label": "Card Number or QR Code",
		"find": "Find",
		"notFound": "No card found for {{q}}.",
		"notFoundQr": "No card found for this QR code.",
		"qrRead": "QR code read",
		"openCard": "Open card",
		"activate": "Activate"
	},
	"filters": {
		"title": "Filter cards",
		"organisation": "Organisation",
		"function": "Function",
		"sport": "Sport",
		"any": "Any",
		"search": "Search",
		"clearAll": "Clear all",
		"apply": "Show cards"
	},
	"cards": {
		"count_one": "{{n}} card",
		"count_other": "{{n}} cards",
		"find": "Find a card",
		"search": "Name, Card or Registration Number",
		"filters": "Filters",
		"filtersCount": "Filters ({{n}})",
		"chips": {
			"states": "Card state",
			"batch": "One print batch"
		},
		"table": {
			"cardNo": "Card no.",
			"name": "Name",
			"function": "Function",
			"organisation": "Organisation",
			"validUntil": "Valid until",
			"state": "State",
			"printed": "Printed",
			"activated": "Activated"
		},
		"row": {
			"open": "Open card of {{name}}"
		},
		"pager": {
			"showing_one": "{{from}}–{{to}} of {{total}} card",
			"showing_other": "{{from}}–{{to}} of {{total}} cards",
			"showingNoTotal": "{{from}}–{{to}}",
			"empty": "No cards"
		},
		"empty": {
			"filteredTitle": "No cards match",
			"filteredDescription": "Try other filters, or clear them.",
			"clearFilters": "Clear filters",
			"noneTitle": "No cards yet",
			"noneDescription": "A card appears here once its record is approved."
		},
		"bulk": {
			"selected_one": "{{n}} selected",
			"selected_other": "{{n}} selected",
			"allSelected_one": "All {{n}} matching card selected",
			"allSelected_other": "All {{n}} matching cards selected",
			"selectAll_one": "Select all {{n}} matching",
			"selectAll_other": "Select all {{n}} matching",
			"allActivatable": "All can be activated",
			"activatableSplit_one": "{{taken}} can be activated, {{skipped}} will be skipped",
			"activatableSplit_other": "{{taken}} can be activated, {{skipped}} will be skipped",
			"addToBatch": "Add to print batch",
			"activate_one": "Activate {{n}}",
			"activate_other": "Activate {{n}}",
			"clear": "Clear selection",
			"nonePrintable": "None of the selected cards can go to print",
			"noneActivatable": "None of the selected cards can be activated"
		}
	},
	"batches": {
		"intro": "Batches made from the Cards list. Make each batch's card files, take them to the print shop, mark the batch back, then mark the cards received.",
		"table": {
			"name": "Batch",
			"status": "Status",
			"cards": "Cards",
			"created": "Made",
			"printed": "Back from printer",
			"notes": "Notes",
			"kind": "Who prints",
			"generated": "Files made",
			"sent": "Sent to printer"
		},
		"row": {
			"open": "Open batch {{name}}"
		},
		"pager": {
			"showing_one": "{{from}}–{{to}} of {{total}} batch",
			"showing_other": "{{from}}–{{to}} of {{total}} batches",
			"showingNoTotal": "{{from}}–{{to}}",
			"empty": "No batches"
		},
		"empty": {
			"title": "No print batches yet",
			"description": "Select approved cards in the Cards list and add them to a print batch."
		},
		"showCards": "Show cards",
		"activate": "Activate these cards",
		"markPrinted": "Back from the printer",
		"markTitle": "Mark {{name}} back from the printer?",
		"markBody_one": "The {{n}} card in this batch becomes ready to collect. This can't be undone.",
		"markBody_other": "All {{n}} cards in this batch become ready to collect. This can't be undone.",
		"markConfirm": "Back from the printer",
		"markDone_one": "{{name}}: {{n}} card back from the printer",
		"markDone_other": "{{name}}: {{n}} cards back from the printer",
		"markFailed": "Couldn't mark the batch printed",
		"introNoc": "Batches the host lets you print yourself. Download the card files (a ZIP of PNGs) and print them.",
		"emptyNoc": {
			"title": "No cards to print yourself",
			"description": "When the host lets you print your own cards, the batch appears here."
		},
		"organisation": "Organisation",
		"send": "Sent to the printer",
		"sendTitle": "Mark {{name}} sent to the printer?",
		"sendBody_one": "The {{n}} card in this batch is marked at the printer. This can't be undone.",
		"sendBody_other": "All {{n}} cards in this batch are marked at the printer. This can't be undone.",
		"sendDone_one": "{{name}}: {{n}} card at the printer",
		"sendDone_other": "{{name}}: {{n}} cards at the printer",
		"sendFailed": "Couldn't mark the batch sent",
		"receive": {
			"title": "Organisations",
			"cards_one": "{{n}} card",
			"cards_other": "{{n}} cards",
			"toReceive": "{{n}} to receive",
			"received": "{{n}} received",
			"markOne": "Mark received",
			"markAll": "Mark all received",
			"confirmTitle": "Mark {{name}}'s cards received?",
			"confirmAllTitle": "Mark every card of {{batch}} received?",
			"confirmBody_one": "{{n}} card becomes Received. Activate it once its holder has it.",
			"confirmBody_other": "{{n}} cards become Received. Activate them once their holders have them.",
			"done_one": "{{n}} card marked received",
			"done_other": "{{n}} cards marked received",
			"failed": "Couldn't mark the cards received"
		},
		"flow": {
			"label": "Batch progress",
			"nextLabel": "Next step:",
			"step": {
				"generate": "Card files made",
				"download": "Card files downloaded",
				"send": "At the printer",
				"back": "Back from printer",
				"receive": "Received by NOCs",
				"activate": "Activated"
			},
			"next": {
				"generate": "press “Generate Card” below. The batch moves on by itself once every card is in the ZIP.",
				"download": "download the card files below and print them yourselves.",
				"waitingNoc": "waiting for {{name}} to download its card files.",
				"send": "take the ZIP to the print shop, then press “Sent to the printer”.",
				"back": "when the printed cards come back from the print shop, press “Back from the printer”.",
				"receive": "hand the cards to each NOC (or post them), then mark them received — all at once, or per NOC in the list below.",
				"activate": "every card is received. Activate the cards when their holders arrive.",
				"downloadHost": "press “Generate Card” below and send the ZIP to {{name}} — or let {{name}} download it from its Print batches tab."
			}
		}
	},
	"history": {
		"intro": "Every bulk activation, newest first.",
		"table": {
			"label": "Activation",
			"when": "When",
			"result": "Result",
			"activated": "Activated",
			"skipped": "Skipped",
			"validUntil": "Valid until"
		},
		"ofTotal": "{{n}} of {{total}}",
		"row": {
			"open": "Open activation {{name}}"
		},
		"pager": {
			"showing_one": "{{from}}–{{to}} of {{total}} activation",
			"showing_other": "{{from}}–{{to}} of {{total}} activations",
			"showingNoTotal": "{{from}}–{{to}}",
			"empty": "No activations"
		},
		"empty": {
			"title": "No activations yet",
			"description": "Activate printed cards from the Cards list. Each activation is listed here."
		},
		"detailSubtitle": "{{when}}, {{name}}",
		"activatedCards": "Activated cards",
		"noneVisible": "None of the cards it activated are yours to see.",
		"exportCsv": "Export CSV",
		"csv": {
			"batch": "Batch"
		}
	},
	"overview": {
		"statsLabel": "Card numbers",
		"stats": {
			"cards": "Cards",
			"cardsNote": "approved records",
			"active": "Active",
			"activeNote": "can enter venues",
			"toActivate": "To activate",
			"toActivateAction": "Activate",
			"view": "View",
			"notPrinted": "Not printed",
			"notPrintedNote": "waiting to print",
			"lost": "Lost",
			"lostNote": "deactivated"
		},
		"stateTitle": "Card status",
		"viewAll": "View all cards",
		"barLabel": "Cards by state",
		"emptyTitle": "No cards yet",
		"emptyHint": "A card appears here once its record is approved.",
		"attention": {
			"title": "Needs attention",
			"toActivate_one": "{{n}} printed card is waiting for activation",
			"toActivate_other": "{{n}} printed cards are waiting for activation",
			"toActivateHint": "Activate them one by one, by QR code, or a whole print batch at once.",
			"toActivateHintNoc": "The organisers activate them when the holder collects the card.",
			"activate": "Activate",
			"view": "View",
			"lost_one": "{{n}} card is reported lost",
			"lost_other": "{{n}} cards are reported lost",
			"lostHint": "The holder can't enter venues with it.",
			"notPrinted_one": "{{n}} approved card is not printed yet",
			"notPrinted_other": "{{n}} approved cards are not printed yet",
			"notPrintedHint": "Select them in Cards and add them to a print batch.",
			"notPrintedHintNoc": "The organisers print them in batches.",
			"clear": "Nothing needs attention",
			"clearHint": "Every card is printed and activated."
		}
	},
	"card": {
		"title": "Card",
		"back": "Back to cards",
		"notFound": "This card doesn't exist, or it isn't one of yours.",
		"markBody": "Every card in batch {{name}} becomes Printed, ready for activation. This can't be undone.",
		"facts": {
			"state": "State",
			"validUntil": "Valid until",
			"activated": "Activated",
			"printed": "Printed"
		},
		"actions": {
			"title": "Actions",
			"none": "Nothing to do on this card right now.",
			"activate": "Activate card",
			"activateHint": "Grant access from today",
			"addToBatch": "Add to print batch",
			"addToBatchHint": "Send this card to print",
			"markPrinted": "Mark printed",
			"markPrintedHint": "Batch {{name}} came off the printer",
			"report": "Report lost or stolen",
			"reportHint": "Deactivates the card at once",
			"download": "Download your card",
			"downloadHint": "The host lets you print it yourself. Open {{name}} and download the card file.",
			"openBatch": "Open its print batch",
			"openBatchHint": "{{name}}: make the card files and follow the batch."
		},
		"access": {
			"title": "Access",
			"function": "Function",
			"codes": "Access codes",
			"none": "No access codes"
		},
		"holder": {
			"title": "Holder",
			"openRecord": "Open record",
			"name": "Name",
			"organisation": "Organisation",
			"sport": "Sport",
			"accreditationNo": "Accreditation no.",
			"registrationNo": "Registration no.",
			"lastIncident": "Last incident",
			"incidentLine": "{{kind}}, {{date}}",
			"police": "Police report {{no}}"
		}
	},
	"visual": {
		"aria": "Accreditation card of {{name}}",
		"qr": "Card QR code",
		"acNo": "AC No."
	},
	"batchKind": {
		"HOST": "Host prints",
		"SELF_PRINT": "NOC prints"
	},
	"batchKindHint": {
		"HOST": "The host takes the ZIP to its print shop.",
		"SELF_PRINT": "Its NOC downloads the ZIP and prints its own cards."
	},
	"generator": {
		"title": "Card files",
		"hint": "Each card is drawn on this computer as a {{w}} × {{h}} px PNG (54 × 85.6 mm at 300 dpi) and packed into one ZIP. Keep this window open until it finishes.",
		"start": "Generate Card",
		"again": "Download the ZIP again",
		"loading": "Getting cards… {{done}} of {{total}}",
		"drawing": "Drawing card {{done}} of {{total}}",
		"zipping": "Packing the ZIP…",
		"done_one": "{{file}} saved: {{n}} card.",
		"done_other": "{{file}} saved: {{n}} cards.",
		"marked": "The batch is marked generated.",
		"preview": "This download is a preview: the batch is marked generated when its NOC downloads it.",
		"failed": "Couldn't make the card files",
		"photoFailed": "The photo of {{name}} ({{no}}) could not be loaded. Try again, or replace the photo.",
		"noPhoto": "{{name}} ({{no}}) has no photo. Add one, then try again.",
		"stop": "Stop",
		"stopped": "Stopped. Nothing was saved or marked.",
		"changed": "The batch changed while its files were being made. Make them again."
	}
}
